import { deletePaymentMethod, fetchPaymentMethods } from 'api/api'

import { createFetcherThunk } from 'redux/thunkCreators'
import { createSlice } from '@reduxjs/toolkit'
import { showError } from './globalError'

export const initialState = []

const paymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
        resetState: _ => initialState,
        paymentMethodsReceived: (_, { payload }) => {
            return payload
        },
        paymentMethodDeleted: (state, { payload }) => {
            return state.filter(pm => pm.token !== payload.token)
        },
    },
})

const { actions, reducer } = paymentSlice // Extract the action creators object and the reducer
export default reducer

//Selectors
export const getPaymentMethods = store => store.payment

//Action creators
export const { resetState, paymentMethodsReceived, paymentMethodDeleted } = actions

//Thunks

export const retrievePaymentMethods = createFetcherThunk(fetchPaymentMethods, null, paymentMethodsReceived)

export const removePaymentMethod = paymentMethod => async dispatch => {
    try {
        await deletePaymentMethod(paymentMethod.token)
        dispatch(paymentMethodDeleted(paymentMethod))
    } catch (err) {
        console.error(err)
        dispatch(
            showError(
                "There's nothing worse than a technical difficulty at a concert, but even live streams can have them. Please try refreshing the page, or try again in a few minutes.",
            ),
        )
    }
}
